import type { TOC } from '@ember/component/template-only';
import { PrismBadge, PrismButton, PrismCard } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';
import type HotelSettingsMyotbIntroController from 'lumen/controllers/hotel/settings/myotb/intro';

interface HotelSettingsMyotbIntroSignature {
  Args: {
    controller: HotelSettingsMyotbIntroController;
    model: unknown;
  };
}

<template>
  {{#if @controller.isSelfServiceFlowEnabled}}
    <PrismCard class="myotb-card">
      <:header as |Header|>
        <Header.title>
          {{t "settings.my_otb.intro.title"}}
        </Header.title>
      </:header>
      <:content>
        <div class="myotb-card__content-container flex flex-col gap-400">
          {{outlet}}

          <div class="flex flex-row gap-400">
            <PrismBadge
              @badgeType="success"
              @iconName="checkmark"
              @iconPosition="left"
              @label={{t "settings.my_otb.intro.free"}}
            />

            <PrismBadge
              @badgeType="success"
              @iconName="checkmark"
              @iconPosition="left"
              @label={{t "settings.my_otb.intro.secure_confidential"}}
            />
          </div>

          <ul class="myotb-ul myotb-ul--default flex flex-col gap-300">
            <li>
              <p class="text-300--bold">{{t
                  "settings.my_otb.intro.reason.1.title"
                }}</p>
              <p class="paragraph-300--regular">{{t
                  "settings.my_otb.intro.reason.1.text"
                }}</p>
            </li>

            <li>
              <p class="text-300--bold">{{t
                  "settings.my_otb.intro.reason.2.title"
                }}</p>
              <p class="paragraph-300--regular">{{t
                  "settings.my_otb.intro.reason.2.text"
                }}</p>
            </li>

            {{#if @controller.hasBenchmarkQuestion}}
              <li>
                <p class="text-300--bold">{{t
                    "settings.my_otb.intro.reason.3.title"
                  }}</p>
                <p class="paragraph-300--regular">{{t
                    "settings.my_otb.intro.reason.3.text"
                  }}</p>
              </li>
            {{/if}}
          </ul>

          <GeneralNavigationIntercomHelpLink
            @articleLink="en/articles/4086741-add-your-otb-data-to-ota-insight"
            @iconName="link-out"
            @isStandaloneLink={{true}}
            @linkText={{t "settings.my_otb.intro.learn_more_link"}}
            @type="text-and-icon"
          />
        </div>
      </:content>

      <:footer>
        <div class="myotb-card__footer" slot="footer">
          <PrismButton
            @iconAfter="arrow-right"
            @label={{t "settings.my_otb.intro_page.start"}}
            @onClick={{@controller.onClickNext}}
            data-test-id="next-button"
          />
        </div>
      </:footer>
    </PrismCard>
  {{else}}
    <PrismCard class="myotb-card">
      <:header as |Header|>
        <Header.title>
          {{t "settings.my_otb.intro.title"}}
        </Header.title>
      </:header>
      <:content>
        <div class="myotb-card__content-container flex flex-col gap-400">
          {{outlet}}

          <div class="flex flex-row gap-400">
            <PrismBadge
              @badgeType="success"
              @iconName="checkmark"
              @iconPosition="left"
              @label={{t "settings.my_otb.intro.free"}}
            />

            <PrismBadge
              @badgeType="success"
              @iconName="checkmark"
              @iconPosition="left"
              @label={{t "settings.my_otb.intro.secure_confidential"}}
            />
          </div>

          <ul class="myotb-ul myotb-ul--default flex flex-col gap-300">
            <li>
              <p class="text-300--bold">{{t
                  "settings.my_otb.intro.reason.1.title"
                }}</p>
              <p class="paragraph-300--regular">{{t
                  "settings.my_otb.intro.reason.1.text"
                }}</p>
            </li>

            <li>
              <p class="text-300--bold">{{t
                  "settings.my_otb.intro.reason.2.title"
                }}</p>
              <p class="paragraph-300--regular">{{t
                  "settings.my_otb.intro.reason.2.text"
                }}</p>
            </li>

            {{#if @controller.hasBenchmarkQuestion}}
              <li>
                <p class="text-300--bold">{{t
                    "settings.my_otb.intro.reason.3.title"
                  }}</p>
                <p class="paragraph-300--regular">{{t
                    "settings.my_otb.intro.reason.3.text"
                  }}</p>
              </li>
            {{/if}}
          </ul>

          <GeneralNavigationIntercomHelpLink
            @articleLink="en/articles/4086741-add-your-otb-data-to-ota-insight"
            @iconName="link-out"
            @isStandaloneLink={{true}}
            @linkText={{t "settings.my_otb.intro.learn_more_link"}}
            @type="text-and-icon"
          />
        </div>
      </:content>
    </PrismCard>
  {{/if}}
</template> satisfies TOC<HotelSettingsMyotbIntroSignature>;
